// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__ZX11-"};